module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-3-c6fdb46ea4bd3a08974f65c57eb467f2.svg";